import { AddonDiscoveryTelemetry } from '@atlassian/amkt-addon-discovery';
import { AppListingTelemetry } from '@atlassian/mpac-app-listing';
import Telemetry from '@atlassian/mpac-telemetry';

import { CategoryTask } from './Category/CategoryTask';
import { CollectionTask } from './Collection/CollectionTask';

export const HomePageTask = Telemetry.createPageViewTask('view-home-page').dependsOn([
  AddonDiscoveryTelemetry.DiscoveryFacetsTask,
  AddonDiscoveryTelemetry.DiscoveryCollectionsTask,
]);

export const SearchPageTask = Telemetry.createPageViewTask('view-search-results-page').dependsOn([
  AddonDiscoveryTelemetry.SearchTask,
]);

export const AppListingPageTask = Telemetry.createPageViewTask('view-app-listing-page').dependsOn([
  AppListingTelemetry.AppListingTask,
]);

export const CollectionPageTask = Telemetry.createPageViewTask('view-collection-page').dependsOn([
  CollectionTask,
]);

export const CategoryPageTask = Telemetry.createPageViewTask('view-category-page').dependsOn([
  CategoryTask,
]);
